<template lang="pug">
  #wt-upload-file
    WtTile(child vertical :col="12")
        BField
            BUpload.file-upload-input.custom-file-upload-input.mb-2(
                v-model="dropFiles"
                :multiple="multiple"
                :dragDrop="dragDrop"
                native
                :accept="accept"
                :disabled="disabled"
            )
                section.content.has-text-centered
                    BIcon(:icon="uploadIcon" :size="uploadIconSize")
                    p
                        slot(name = "custom-upload-lable")

        .level.mt-4(v-if="showSaveButton")
          WtButton.save-button(
            is-rounded
            color="primary"
            @click.native="saveFile"
          ) Save
        BTaglist(v-if="multiple")
            span(
                    v-for="(file, index) in dropFiles" :key="index"
                ).tag.is-primary.pr-2 {{ file.name }}
                    button(
                        class="delete is-small" type="button" @click="deleteFile(index)"
                    )
        BTag(v-if="!multiple")
            span(v-if="dropFiles && dropFiles.length != 0")
                .tag.is-primary {{ dropFiles.name }}
                    button(
                        class="delete is-small" type="button" @click="deleteFile()"
                    )

</template>
<script>
import WtTile from "@@/WtTile/WtTile";
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "WtUploadFile",
  components: {
    WtTile,
    WtButton
  },
  props: {
    accept: {
      type: String,
      Required: true,
      default: "text/csv"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    dragDrop: {
      type: Boolean,
      default: true
    },
    uploadIcon: {
      type: String,
      default: "upload"
    },
    uploadIconSize: {
      type: String,
      default: "is-large"
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fileData: {
      type: [File, Array, null],
      default: null
    }
  },
  data() {
    return {
      file: {},
      dropFiles: this.multiple ? [] : null
    };
  },
  computed: {
    showSaveButton() {
      if (this.multiple) {
        return this.fileData && this.fileData?.length;
      } else {
        return this.fileData;
      }
    }
  },
  watch: {
    dropFiles() {
      this.$emit("updateFile", this.dropFiles);
    },
    fileData() {
      this.dropFiles = this.fileData;
    }
  },
  methods: {
    deleteFile(index) {
      this.$emit("deleteFile", index);
    },
    saveFile() {
      this.$emit("save", this.fileData);
    }
  }
};
</script>
<style lang="sass">
#wt-upload-file
  display: flex
  flex-direction: column
  .file-upload-input
    .upload-draggable
      margin-bottom: 0rem
      padding: 1rem 2rem 1rem 2rem
    .custom-file-upload-input
      display: flex
      align-items: center
      justify-content: center
</style>
